import _find from 'lodash/find';
import _map from 'lodash/map';
import _includes from 'lodash/includes';
import _difference from 'lodash/difference';
import _intersection from 'lodash/intersection';
import _head from 'lodash/head';
import _last from 'lodash/last';

/**
 * button_variables that are supported in the Wizard UI
 */
const donateButtonVariables = [
	'amount',
	'business',
	'item_name',
	'item_number',
	'currency_code',
	'bn',
	'cancel_return',
	'no_note',
	'no_shipping',
	'return_url',
	'lc',
	'cpp_header_image',
	'return'
];

/**
 * button_variables supported by buttonFactoryServ
 */
const allSupportedButtonVariables = [
	'business',
	'item_name',
	'item_number',
	'currency_code',
	'PageButtonBgColor',
	'PageButtonTextColor',
	'PageCollapseBgColor',
	'PageCollapseTextColor',
	'PageTitleTextColor',
	'a1',
	'a2',
	'a3',
	'add',
	'address1',
	'address2',
	'address_override',
	'billing_address1',
	'billing_address2',
	'billing_city',
	'billing_country',
	'billing_first_name',
	'billing_last_name',
	'billing_state',
	'billing_zip',
	'bn',
	'bodyBgColor',
	'bodyBgImg',
	'cancel_return',
	'cbt',
	'city',
	'cn',
	'country',
	'custom',
	'disp_tot',
	'first_name',
	'fixed_denom',
	'footerTextColor',
	'footerTextlinkColor',
	'headerBgColor',
	'headerHeight',
	'invoice',
	'last_name',
	'lc',
	'logoFont',
	'logoFontColor',
	'logoFontSize',
	'logoImage',
	'logoImagePosition',
	'logoText',
	'logo_url',
	'max_text',
	'min_amount',
	'night_phone_a',
	'night_phone_b',
	'night_phone_c',
	'no_note',
	'no_shipping',
	'notify_url',
	'orderSummaryBgColor',
	'orderSummaryBgImage',
	'p1',
	'p2',
	'p3',
	'paymentaction',
	'pp_note',
	'return',
	'return_url',
	'rm',
	'set_customer_limit',
	'shipping',
	'shopping_url',
	'showBillingAddress',
	'showBillingEmail',
	'showBillingPhone',
	'showCardInfo',
	'showCustomerName',
	'showHostedThankyouPage',
	'showShippingAddress',
	'sold_out_url',
	'sra',
	'src',
	'srt',
	'state',
	'style_color',
	'style_color',
	'style_theme',
	'subtotal',
	't1',
	't2',
	't3',
	'tax',
	'tax_rate',
	'template',
	'undefined_quantity',
	'usr_manage',
	'weight',
	'weight_unit',
	'zi'
];

const getButtonVariable = (buttonVariables, key) => {
	return _find(buttonVariables, { name: key })
}

const getNames = (buttonVariables) => {
	return _map(buttonVariables, 'name');
}

const getButtonVariables = (buttonVariables, names) => {
	return _map(names, (name) => {
		return getButtonVariable(buttonVariables, name)
	});
}

export const isSupportedVariable = (name) => {
	return _includes(allSupportedButtonVariables, name);
}

/**
 * Gets all the 'button_variables' that are considered "extra" or "advanced"
 *
 * Any button_variable that is not handled in any of the wizard
 * steps are considered extra or advanced
 * Eg: 'amount' is a button_variable but it has a dedicated field in wizard step 3
 * So 'amount' is not an extra/advanced variable
 */
export const getExtraVariables = (buttonVariables) => {
	const buttonVariableNames = getNames(buttonVariables);
	const extraVariables = _difference(buttonVariableNames, donateButtonVariables);

	return getButtonVariables(buttonVariables, extraVariables);
}

/**
 * Gets all button variables that are unsupported by ButtonFactory
 * 
 * Webscr button factory allows users to input *any* variable that they want.
 * But not all the button_variables are "supported"
 * 
 */
export const getUnsupportedVariables = (buttonVariables) => {
	const extraVariables = getExtraVariables(buttonVariables);
	const extraVariableNames = getNames(extraVariables);

	const unsupportedVariableNames = _difference(extraVariableNames, allSupportedButtonVariables);

	return getButtonVariables(buttonVariables, unsupportedVariableNames);
}

/**
 * Gets all button_variables that are supported by ButtonFactory
 */
export const getSupportedVariables = (buttonVariables) => {
	const extraVariables = getExtraVariables(buttonVariables);
	const extraVariableNames = getNames(extraVariables);
	const supportedVariableNames = _intersection(extraVariableNames, allSupportedButtonVariables);

	return getButtonVariables(buttonVariables, supportedVariableNames);
}

/**
 * Creates view for the textarea used for extra/advanced variables.
 * 
 */
export const generateViewForSupportedVars = (buttonVariables) => {
	const supportedVariables = getSupportedVariables(buttonVariables);
	const variables = _map(supportedVariables, (supportedVariable) => {
		return `${supportedVariable.name}=${supportedVariable.value}`;
	});
	return variables.join('\n');
}

export const formatVariablesForTextArea = (buttonVariables) => {
	const variables = _map(buttonVariables, (buttonVariable) => {
		return `${buttonVariable.name}=${buttonVariable.value}`;
	});
	return variables.join('\n');
}

export const parseTextAreaValue = (textAreaValue) => {
	const variables = textAreaValue.split('\n');
	let extraVariables;

	try {
		extraVariables = _map(variables, (variable) => {
			const input = variable.split('=');
			return {
				name: _head(input),
				value: _last(input)
			}
		})

	} catch (e) {
		console.log('Exception occurred while parsing user input ');
	}

	return extraVariables;
}



// WEBPACK FOOTER //
// ./buttons/lib/extraVariables.js